import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg_ash pt-57" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_ResponsiveNavbar = _resolveComponent("ResponsiveNavbar")!
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_ContactInfo = _resolveComponent("ContactInfo")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_ResponsiveNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BreadCrumb, { pageTitle: "Contact" }),
        _createVNode(_component_ContactInfo)
      ])
    ]),
    _createVNode(_component_ContactForm),
    _createVNode(_component_MainFooter)
  ], 64))
}